import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

// Công khai như signin: trên POS dùng chung, "mở tài khoản khác khi máy đang đăng nhập" là nhu cầu
// thật. `SignUp.vue` tự tiêu thụ cờ just-verified của mình.
export const signupRoutes = {
  name: 'signup',
  path: 'signup',
  components: {
    default: () => import('./SignUp.vue'),
    brand: () => import('./SignUpBrand.vue'),
  },
  meta: {
    i18n,
    authHeader: { titleKey: 'signup.heading', subtitleKey: 'signup.subtitle' },
  },
} satisfies RouteRecordRaw;
